module.exports = __webpack_public_path__ + "img/logo-2-dark.d2315fe0.svg";